export class FormDocumentMedia {
  RecordId?: number;
  DocumentId: string;
  Value: string;
  Thumbnail?: string;

  constructor(obj?: Partial<FormDocumentMedia>) {
    if (obj) {
      Object.assign(this, obj);
    }
    else {
      throw Error('Object cannot be null');
    }
  }
}
